import Swal from 'sweetalert2';
import {
    upload_videoGuideCreateApi,
    videoGuide_listAPI,
    videoGuide_deleteAPI,
    edit_video_guideAPI,
    videoGuide_EditlistAPI,
} from '../../Apis/user/ApiConfig';
import {
    CREATE_VIDEO_GUIDE_SUCCESS,
    CREATE_VIDEO_GUIDE_ERROR,
    CREATE_VIDEO_GUIDE_REQUEST,
    LIST_VIDEO_GUIDE_SUCCESS,
    LIST_VIDEO_GUIDE_ERROR,
    LIST_VIDEO_GUIDE_REQUEST,
    LIST_EDIT_VIDEO_GUIDE_SUCCESS,
    LIST_EDIT_VIDEO_GUIDE_ERROR,
    LIST_EDIT_VIDEO_GUIDE_REQUEST,
    DELETE_VIDEO_GUIDE_SUCCESS,
    DELETE_VIDEO_GUIDE_ERROR,
    DELETE_VIDEO_GUIDE_REQUEST,
    EDIT_VIDEO_GUIDE_SUCCESS,
    EDIT_VIDEO_GUIDE_ERROR,
    EDIT_VIDEO_GUIDE_REQUEST,
} from '../../Types/user/Types';

export const create_video_guide_success = (res) => {
    return {
        type: CREATE_VIDEO_GUIDE_SUCCESS,
        payload: res,
    };
};
export const create_video_guide_error = (error) => {
    return {
        type: CREATE_VIDEO_GUIDE_ERROR,
        error: error,
    };
};

export const create_video_guide_request = (res) => {
    return {
        type: CREATE_VIDEO_GUIDE_REQUEST,
        payload: res,
    };
};

export const list_video_guide_success = (res) => {
    return {
        type: LIST_VIDEO_GUIDE_SUCCESS,
        payload: res,
    };
};
export const list_video_guide_error = (error) => {
    return {
        type: LIST_VIDEO_GUIDE_ERROR,
        error: error,
    };
};

export const list_video_guide_request = (res) => {
    return {
        type: LIST_VIDEO_GUIDE_REQUEST,
        payload: res,
    };
};

export const list_edit_video_guide_success = (res) => {
    return {
        type: LIST_EDIT_VIDEO_GUIDE_SUCCESS,
        payload: res,
    };
};
export const list_Edit_video_guide_error = (error) => {
    return {
        type: LIST_EDIT_VIDEO_GUIDE_ERROR,
        error: error,
    };
};

export const list_edit_video_guide_request = (res) => {
    return {
        type: LIST_EDIT_VIDEO_GUIDE_REQUEST,
        payload: res,
    };
};

export const delete_video_guide_success = (res) => {
    return {
        type: DELETE_VIDEO_GUIDE_SUCCESS,
        payload: res,
    };
};

export const delete_video_guide_error = (error) => {
    return {
        type: DELETE_VIDEO_GUIDE_ERROR,
        error: error,
    };
};

export const delete_video_guide_request = (res) => {
    return {
        type: DELETE_VIDEO_GUIDE_REQUEST,
        payload: res,
    };
};
export const edit_video_guide_success = (res) => {
    return {
        type: EDIT_VIDEO_GUIDE_SUCCESS,
        payload: res,
    };
};

export const edit_video_guide_error = (error) => {
    return {
        type: EDIT_VIDEO_GUIDE_ERROR,
        error: error,
    };
};

export const edit_video_guide_request = (res) => {
    return {
        type: EDIT_VIDEO_GUIDE_REQUEST,
        payload: res,
    };
};

export const create_video_guide_ActionHandler = (data, Navigate) => {
    return (dispatch) => {
        dispatch(create_video_guide_request(data));
        try {
            upload_videoGuideCreateApi(data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Successfully Uploaded Video!',
                                showConfirmButton: false,
                                timer: 1500,
                            }).then(() => {});
                            dispatch(create_video_guide_success(res?.data));
                            dispatch(list_video_guide_ActionHandler());
                        } else {
                            let data = res?.response?.data?.data;
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Something went wrong!',
                                html: `
                      <p>${data?.name ? data?.name[0] : ''}</p>
                  `,
                                confirmButtonColor: 'rgb(231,52,70)',
                            });
                            dispatch(create_video_guide_error(res));
                        }
                    } else {
                        dispatch(create_video_guide_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        create_video_guide_error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(create_video_guide_error(err));
        }
    };
};

// export const list_video_guide_ActionHandler = (searchText) => {
//   return (dispatch) => {
//     dispatch(list_video_guide_request(searchText));
//     try {
//       const apiCall = searchText ? videoGuide_listAPI(searchText) : videoGuide_listAPI();
//       apiCall
//         .then((res) => {
//           if (res) {
//             if (res && res?.data && res?.status === 200) {
//               dispatch(list_video_guide_success(res?.data));
//             } else {
//               dispatch(list_video_guide_error(res));
//             }
//           } else {
//             dispatch(list_video_guide_error(""));
//           }
//         })
//         .catch((err) => {
//           dispatch(list_video_guide_error("Something Went Wrong!!!"));
//         });
//     } catch (err) {
//       dispatch(list_video_guide_error(err));
//     }
//   };
// };

export const list_edit_video_guide_ActionHandler = () => {
    return (dispatch) => {
        dispatch(list_edit_video_guide_request());
        try {
            videoGuide_EditlistAPI()
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(list_edit_video_guide_success(res?.data));
                            dispatch(create_video_guide_success(res?.data));
                        } else {
                            dispatch(list_Edit_video_guide_error(res));
                        }
                    } else {
                        dispatch(list_Edit_video_guide_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        list_Edit_video_guide_error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(list_Edit_video_guide_error(err));
        }
    };
};

export const list_video_guide_ActionHandler = (searchText) => {
    return (dispatch) => {
        dispatch(list_video_guide_request(searchText));
        try {
            videoGuide_listAPI(searchText)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(list_video_guide_success(res?.data));
                            dispatch(create_video_guide_success(res?.data));
                        } else {
                            dispatch(list_video_guide_error(res));
                        }
                    } else {
                        dispatch(list_video_guide_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(list_video_guide_error('Something Went Wrong!!!'));
                });
        } catch (err) {
            dispatch(list_video_guide_error(err));
        }
    };
};

export const delete_video_guide_ActionHandler = (videoGuideId) => {
    return (dispatch) => {
        dispatch(delete_video_guide_request());
        try {
            videoGuide_deleteAPI(videoGuideId)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Successfully Deleted Video Guide!',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            dispatch(delete_video_guide_success(res?.data));
                            dispatch(list_video_guide_ActionHandler());
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Something went wrong!',
                            });
                            dispatch(delete_video_guide_error(res));
                        }
                    } else {
                        dispatch(delete_video_guide_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        delete_video_guide_error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(delete_video_guide_error(err));
        }
    };
};

export const edit_video_guide_ActionHandler = (id, data) => {
    return (dispatch) => {
        dispatch(edit_video_guide_request());
        try {
            edit_video_guideAPI(id, data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Successfully Edited Video Guide!',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            dispatch(edit_video_guide_success(res?.data));
                            dispatch(list_video_guide_ActionHandler());
                        } else {
                            let data = res?.response?.data?.data;
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Something went wrong!',
                            });
                            dispatch(edit_video_guide_error(res));
                        }
                    } else {
                        dispatch(edit_video_guide_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(edit_video_guide_error('Something Went Wrong!!!'));
                });
        } catch (err) {
            dispatch(edit_video_guide_error(err));
        }
    };
};
